import { axiosClient } from './base'
const LIST_GOVERNORATE = '/api/governorate'

export const getGovernorates = () =>
  axiosClient.get(LIST_GOVERNORATE)
